module.exports = __webpack_public_path__ + "static/media/imgComing.d50bb4f3.svg";